/* eslint-disable indent */
import { useLocation, Navigate } from 'react-router-dom';
import { RoleName } from '@/api/entities/user-role-type';
import { useAuth, useUserRole } from '@/hooks/auth.hooks';

interface ProtectedRouteProps {
  allowedRoles: RoleName[];
  element: React.ReactNode;
  allowedQueries?: Record<string, string>[];
}

export const RoleProtectedRoute = ({
  allowedRoles,
  element,
  allowedQueries,
}: ProtectedRouteProps) => {
  const { primaryRole, isAuthReady } = useAuth();
  const { hasNoRole, isAdmin, isModerator } = useUserRole();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const navigateForUnauthorized = (
    <Navigate
      to={
        hasNoRole
          ? '/users'
          : isModerator
          ? '/moteur-de-correction-liste'
          : '/dashboard'
      }
      replace
    />
  );

  if (isAuthReady) {
    if (isAdmin) {
      return <>{element}</>;
    }

    if (
      hasNoRole &&
      (location.pathname === '/users' ||
        location.pathname.startsWith('/user/edit'))
    ) {
      return <>{element}</>;
    }

    if (!allowedRoles?.includes(primaryRole)) {
      return navigateForUnauthorized;
    }

    if (allowedQueries && allowedQueries.length > 0) {
      const hasValidQueryStrings = allowedQueries.some((queryObj) => {
        return Object.entries(queryObj).every(
          ([key, value]) => searchParams.get(key) === value
        );
      });

      if (!hasValidQueryStrings) {
        return navigateForUnauthorized;
      }
    }
  }

  return <>{element}</>;
};
